type Translate = (key: string, options: { name: string }) => string;

/** Whether a contest is a special election (Democracy Works `contestType`). */
export const isSpecialElection = (contest: { contestType?: string | null }): boolean =>
  (contest.contestType ?? '').trim().toLowerCase() === 'special';

/**
 * Whether a contest is a judicial retention vote: one sitting judge, and the
 * voter marks Yes or No on keeping them (`contestType: "retention"`).
 */
export const isRetentionContest = (contest: { contestType?: string | null }): boolean =>
  (contest.contestType ?? '').trim().toLowerCase() === 'retention';

/**
 * The name a contest is shown, read aloud, and asked about by. One office can
 * hold a regular and a special election on the same ballot under the same name
 * (Phoenix Elementary's at-large board seats, November 2026), so the special one
 * is marked; unmarked, the two read as one race listed twice.
 *
 * @param t The `ballot` namespace's translator.
 */
export const contestDisplayName = (
  contest: { name: string; contestType?: string | null },
  t: Translate
): string =>
  isSpecialElection(contest) && !/special election/i.test(contest.name)
    ? t('elections.specialElectionName', { name: contest.name })
    : contest.name;
